import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "customergroup-query"
    }}>{`customerGroup query`}</h1>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`This query is part of the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/developer/commerce/storefront/setup/configuration/storefront-compatibility/v248/"
      }}>{`Storefront Compatibility Package`}</a>{`. It will be added to Adobe Commerce 2.4.9.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`customerGroup`}</inlineCode>{` query provides encoded ID of Customer Group assigned to the Logged-in Customer or Guest shopper.`}</p>
    <p>{`To retrieve customer group for a customer, we recommend you use customer tokens in the header of your GraphQL calls. However, in case of guest information, token should not be passed.`}</p>
    <h2 {...{
      "id": "syntax"
    }}>{`Syntax`}</h2>
    <p><inlineCode parentName="p">{`{customerGroup: {CustomerGroupStorefront!}}`}</inlineCode></p>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <p>{`The following call returns encoded ID of customer group for logged-in customer or guest. Provide the customer's token in the header section of the query in case of logged-in customer.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`{
    customerGroup {
        uid
    }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "customerGroup": {
      "uid": "MA=="
    }
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      